import shop from './shop';
import home from './home';
import cover from "./cover";
import photo from "./photo";
import series from "./series";

export default {
    shop, home, cover, photo, series
}
